import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FJImageCropModal from './FJImageCropModal';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionModal from '../../../redux/action/FJActionModal';
import FJModal from '../FJModal';

const FJImageCropModalContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    // 从 Redux store 获取状态
    const imageCropModalData = useSelector(state => state.modals.imageCropModalData);
    const {
        display,
        imageUrl,
        onConfirm,
        onCancel,
        outputType,
        minHeight,
        minWidth,
        maxHeight,
        maxWidth,
        hasCropRatio,
        initCropRatio,
        initCropRect,
    } = imageCropModalData;

    // 确认裁剪
    const handleConfirm = useCallback(
        async croppedFile => {
            // 调用外部传入的确认回调
            if (onConfirm && croppedFile) {
                onConfirm(croppedFile);
            }

            // 关闭模态框
            dispatch(FJActionModal.hideImageCropModalAction());
        },
        [dispatch, onConfirm],
    );

    // 取消裁剪
    const handleCancel = useCallback(() => {
        // 调用外部传入的取消回调
        if (onCancel) {
            onCancel();
        }

        // 关闭模态框
        dispatch(FJActionModal.hideImageCropModalAction());
    }, [dispatch, onCancel]);

    // 清理 Object URL 以避免内存泄漏
    useEffect(() => {
        return () => {
            if (imageUrl && imageUrl.startsWith('blob:')) {
                URL.revokeObjectURL(imageUrl);
            }
        };
    }, [imageUrl]);

    return (
        <FJModal visible={display}>
            <FJImageCropModal
                imageUrl={imageUrl}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
                minHeight={minHeight}
                minWidth={minWidth}
                maxHeight={maxHeight}
                maxWidth={maxWidth}
                outputType={outputType}
                hasCropRatio={hasCropRatio}
                initCropRatio={initCropRatio}
                initCropRect={initCropRect}
            />
        </FJModal>
    );
};

export default FJImageCropModalContainer;
